import { useState } from 'react';
import AppLayout from '../../components/AppLayout';
import LiveFleetMap from '../../components/LiveFleetMap';
import useLiveFleet from '../../components/useLiveFleet';

const DispatchMap = () => {
  const fleet = useLiveFleet();
  const [filter, setFilter] = useState('all');

  const headerActions = (
    <button
      type="button"
      className="btn btn-ghost"
      onClick={() => fleet.refresh().catch(() => {})}
      disabled={fleet.refreshing}
    >
      {fleet.refreshing ? 'Refreshing…' : 'Refresh'}
    </button>
  );

  return (
    <AppLayout
      title="Live Dispatch Map"
      subtitle="Real-time driver positions — online and offline."
      actions={headerActions}
    >
      <div className="dispatch-map-outer">
        <LiveFleetMap
          drivers={fleet.drivers}
          loading={fleet.loading}
          error={fleet.error}
          freshnessNow={fleet.freshnessNow}
          serviceCenter={fleet.serviceCenter}
          serviceZoom={fleet.serviceZoom}
          filter={filter}
          variant="full"
        />

        <div className="dmap-controls">
          <div className="dmap-controls__header">
            <span className={`dmap-live-pulse${fleet.connected ? '' : ' is-offline'}`} />
            <span className="dmap-controls__title">{fleet.connected ? 'Live Dispatch' : 'Reconnecting'}</span>
          </div>

          <div className="dmap-stats">
            <div className="dmap-stat dmap-stat--online">
              <span className="dmap-stat__dot" />
              <span>{fleet.counts.available} Available</span>
            </div>
            <div className="dmap-stat dmap-stat--ontrip">
              <span className="dmap-stat__dot" />
              <span>{fleet.counts.onTrip} On Trip</span>
            </div>
            <div className="dmap-stat dmap-stat--offline">
              <span className="dmap-stat__dot" />
              <span>{fleet.counts.offline} Offline</span>
            </div>
          </div>

          <div className="dmap-filter-row" aria-label="Vehicle status filter">
            {[
              { key: 'all', label: 'All' },
              { key: 'online', label: 'Available' },
              { key: 'ontrip', label: 'On Trip' },
              { key: 'offline', label: 'Offline' },
            ].map(({ key, label }) => (
              <button
                key={key}
                type="button"
                className={`dmap-filter-btn ${filter === key ? 'active' : ''}`}
                onClick={() => setFilter(key)}
                aria-pressed={filter === key}
              >
                {label}
              </button>
            ))}
          </div>

          {fleet.counts.noLocation > 0 ? (
            <p className="dmap-no-loc">
              {fleet.counts.noLocation} driver{fleet.counts.noLocation === 1 ? '' : 's'} awaiting first ping
            </p>
          ) : null}
        </div>

        <div className="dmap-legend" aria-label="Vehicle map legend">
          <div className="dmap-legend__item">
            <span className="dmap-legend__swatch dmap-legend__swatch--online" />
            Available
          </div>
          <div className="dmap-legend__item">
            <span className="dmap-legend__swatch dmap-legend__swatch--ontrip" />
            On Trip
          </div>
          <div className="dmap-legend__item">
            <span className="dmap-legend__swatch dmap-legend__swatch--offline" />
            Offline
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default DispatchMap;
